import type {
  AiContextExplanation,
  AiContextImage,
  WordInsight,
} from "../types";

type DictionaryPayload = {
  word: string;
  context: string;
  targetLanguage: string;
  targetLanguageCode: string;
};

export async function lookupDictionaryWord(
  payload: DictionaryPayload,
  signal?: AbortSignal,
): Promise<WordInsight> {
  const response = await fetch("/api/dictionary", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    signal,
  });
  const body = (await response.json().catch(() => null)) as
    | (WordInsight & { error?: string })
    | null;
  if (!response.ok || !body) {
    throw new Error(body?.error ?? "Kelime sözlükte bulunamadı.");
  }
  return body;
}

type AiExplanationPayload = {
  word: string;
  context: string;
};

export async function explainWordInContext(
  payload: AiExplanationPayload,
  idToken: string,
  signal?: AbortSignal,
): Promise<AiContextExplanation> {
  const response = await fetch("/api/context-explanation", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
    signal,
  });
  const body = (await response.json().catch(() => null)) as
    | (AiContextExplanation & { error?: string })
    | null;
  if (!response.ok || !body) {
    throw new Error(body?.error ?? "AI açıklaması hazırlanamadı.");
  }
  return body;
}

export async function lookupContextImage(
  query: string,
  signal?: AbortSignal,
): Promise<AiContextImage | null> {
  const response = await fetch("/api/context-image", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ query }),
    signal,
  });
  const body = (await response.json().catch(() => null)) as
    | { image: AiContextImage | null; error?: string }
    | null;
  if (!response.ok || !body) {
    throw new Error(body?.error ?? "Uygun görsel aranamadı.");
  }
  return body.image;
}
